// extracted by mini-css-extract-plugin
module.exports = {"page-section":"GPwvEJY","pageSection":"GPwvEJY","invite-holder":"BE02NIF","inviteHolder":"BE02NIF"};